import { NgClass } from "@angular/common";
import { Component, computed, inject, Input } from "@angular/core";
import {
  ProposalHistoryDetails,
  ProposalHistoryItem,
  ProposalHistoryOtherExamComponent,
} from "@app/core/domain/proposal-history";
import { PlanStateService } from "@app/shared/services/plan-state.service";
import { TranslatePipe } from "@ngx-translate/core";
import { AddCourseListHeaderComponent } from "@shared/components/add-course-list-header/add-course-list-header.component";
import { HistoryCourseItemComponent } from "../history-course-item/history-course-item.component";

@Component({
  selector: "pa-history-courses",
  templateUrl: "./history-courses.component.html",
  styleUrls: ["./history-courses.component.scss"],
  imports: [AddCourseListHeaderComponent, HistoryCourseItemComponent, NgClass, TranslatePipe],
})
export class HistoryCoursesComponent {
  @Input() historyItem!: ProposalHistoryItem;
  @Input() historyDetails!: ProposalHistoryDetails;

  private readonly planStateService = inject(PlanStateService);

  protected planAllowsChangeExamComponent = computed(
    () => this.planStateService.currentSelectedPlan()?.allowsChangeExamComponent,
  );

  getExamComponentName(examComponent: ProposalHistoryOtherExamComponent): string {
    return examComponent.specialisationName
      ? `${examComponent.name} (${examComponent.specialisationName})`
      : examComponent.name;
  }
}
